module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "ch3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRCLE")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p01-01.jpg"
    }
  }), _vm._v(" Later that night, Guy lay on top of his comforter, feeling lonely. His parents had gone to bed. Anne had called at nine to say she was still coming to give him his massage. Guy rolled over to face his clock. 10:07. Anytime this century, Anne.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("James wasn't home yet from the second of his two jobs, as a supervisor at a home for mentally impaired adults. Guy had urged him to abandon it. Put all your energy into becoming a manager at Nordstrom, he advised him, like I did; make it your career. But James enjoyed working at the home; everyone told him he was good with the people there, loving and patient.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('i', [_vm._v("I don't know how James does it. I mean, the work at Nordstrom can be tedious—really hard work at times, but still, there are those moments when everybody is bustling around, getting ready for a sale, making the store dazzle. Or when we're previewing a new line of clothes and deciding where to put it, how to display it, what to tell the customers to make them buy it. I loved all that. And even though I have my new career now, talking to kids, keeping them alive, I still miss it sometimes.")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('i', [_vm._v("James leaves Nordstrom and goes to a place full of crazy people. Nice crazy people, he tells me. He really likes them. I admire him for that. And "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("I can understand, because james can be very gentle and caring. When he's not being a weenie.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("He was just drifting off when he heard doors and voices downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Annie?” he called out, leaning up on his elbows to peer into the hall. But it was James who bounded up the stairs and filled the doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“She's here. Should I tell her to come up?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Not until I get a kiss hello.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Wow, that's a switch.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Don't start.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("James leaned over the bed and obliged Guy with a playful peck.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Stripping off his tie and shirt as he went into the room next door, James declared, “Let's get her up here and get this back rub going. I want to go to bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“You can just go sleep somewhere else,” Guy called after him. “I want to take my time. Everything hurts.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Each night for months, Anne had arrived with her bottle of oil and her experienced hands to give Guy one of the few physical pleasures he still looked forward to. No matter how tired she was, Anne was faithful to the routine, and Guy appreciated her devotion, though he expected as much from a best friend. For now, being Guy Nakatani's best friend defined her. Anne had come to accept that role, with far less difficulty than she accepted the fact that soon Guy would be leaving her, taking their friendship with him into eternity, and she would have to find herself all over again.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Clad in cut-off jeans and a Grateful Dead T-shirt, she entered Guy's room just behind James. They lined up next to Guy's bed.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“James, move your big booty,” Anne teased, giving him a shove.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Who's got the big booty?” he inquired sweetly.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("She frowned. “I'm running every day.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“No, Anne,” came the voice from the bed. “You're not running every day. You didn't run today or yesterday. Did you run yesterday?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("“No, but I'm going to run tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“That's not every day. You never stick to anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Don't make me mad, Guy. I'll rub you away.” She handed James the oil. “You do his legs; I'll do his back.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Guy was taking his shirt off with some amount of difficulty, having already donned a pair of sweat shorts. The down comforter was rolled back. “No oil on my comforter,” Guy always reminded Anne. He stretched out on his stomach and breathed out a happy sigh of anticipation.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("James and Anne spread oil on Guy's body and began to massage his light brown, flawless skin. His once robust gymnast's build had slowly shriveled down to acceptably thin.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Does that hurt, Guy?” James asked. “You don't have any fat anymore. I'm bumping into your bones.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Guy murmured something about not caring, and they worked quietly for a while.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('i', [_vm._v("If I had been James and James had been me, I don't think I would have stayed. Oh, by the way, I'm HIV-positive. Honestly, the way I used to function, I probably would have bolted. I hope he never thinks, what a fool I am.")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('i', [_vm._v("Of course I was searching for intimacy, but James and I managed that for only a little while. Sometimes I still get the feeling, though. When he calls me the day I go to the doctor. How was it? What did he say? Or when he knows I woke up feeling terrible. He waits about two hours and then he phones. Are things better? Just the normal things people that love each other do. I like that. I've never had that before.")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('i', [_vm._v("Like the time he said, you know we're supposed to be honest about everything, right? So he sits me down and tells me: A man brought me flowers. Of course, I was jealous. But for him to be consciously aware that this is something he needs to tell me, yes, these are the things that make me feel intimate.")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('i', [_vm._v("A back rub emotionally satisfies me. It's the feeling of someone touching my body, massaging my scalp, touching my back and not my penis. "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("It's an innocent touch. I can relax.")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('i', [_vm._v("Maybe it goes back to when I was little and my dad used to give me back rubs. I thought they were just the most wonderful thing. I think having that experience as a child comforts me now as an adult. I remember what life can feel like.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The door to Jane and Alexander's room opened.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Guy” came a loud whisper across the hall. Jane entered her son's room and eased herself down onto the bed next to his head. “Well, aren't you spoiled,” she admonished him with a tender touch to his damp forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Massage my scalp, Mom?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Guy turned over. Jane worked her fingers lovingly through her son's hair and onto his face, carving out gentle lines across his cheeks and up to his temple. James and Anne moved over the rest of his body, massaging any spot they may have missed.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("A chuckle coming from the doorway caused them all to look up. “This is nice. Where do I get in line?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Hi, Dad,” Guy purred underneath his mother's hands.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Without a word, James and Anne shifted a little, making room for Alexander. Together, they comforted Guy, until his breathing slowed and he slept, his burdens put temporarily to rest.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("James and Anne went downstairs to the kitchen, looking for a snack. Back in their own room, Jane joined her husband in bed.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Aren't you going to turn off the light?” Alexander asked after a minute. He rolled over to face his wife, who was lying on her back, eyes open, her arms folded tightly over her chest.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“You look relaxed,” he commented.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“You'll never believe what happened to me today. I was so mad, I wasn't even going to tell you.” Jane paused, and Alexander waited. “I got stopped by the police.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Her husband suppressed a smile. “And what crime did you commit?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("“A traffic ticket,” she said, giving him a look of total exasperation. “I got a ticket!”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Alexander simply raised his eyebrows.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“I was in front of Bradley's, you know, that bookstore where I like to go, and there weren't any cars at all, so I made a U-turn in the middle of the street.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Was there a yellow line?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“No yellow line?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Well, there was this little tiny thing in the road.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“You went over a divider?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“It was very low. Not like those big dividers on big streets. I don't know what it was, really—I don't think it was there before. They probably just put it in.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Two words floated through Alexander's head. Wheel alignment.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Oh, brother,” Jane sighed, turning to him. She curled up on her side, her head resting on her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Alexander regarded his wife. She looked so pitiful, like a naughty child who'd been scolded and left to think about what she'd done.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“So what did the cop say?” he asked delicately. Are you crazy, lady? That probably would have been my opening line, he thought.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“He said I'd made an illegal turn. I said I was sorry, but that I'd had a lot on my mind lately. He said, like what? So I told him the whole story. First I told him about Greg and then about Glen and then Guy. Can you believe it? He gave me the ticket anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“So did you get out of the car and let him have it?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Oh, Al, of course not. Why would I do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Why not? Remember that tenant, the really filthy guy who ruined our rental house in San Luis? You ran after him with a bat. You were swearing at him, all the way down the street. You called him names.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“That was different. He made me really mad.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“I guess so,” Al grinned at her. “You called him a dirty fag.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Oh God,” Jane groaned, scrunching up her pillow. “See how terrible I was? I didn't know what I was saying.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("“You're not so terrible.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“You know, I felt silly. I finally figured out the cop didn't believe me. I mean, who would believe all that?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“How hard were you crying?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“I wasn't crying at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“You mean to tell me that you got through the whole story without shedding a tear, and any other time, when someone even looks at you funny, you're a weepy mess?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“I was trying to remain calm.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“lane, this was a time for hysteria.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“You're right. i don't know what happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Their eyes met and they laughed together, conscious of their shared understanding, feeling, as they often did, all the things that both united them and set them apart, two against the world.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“You know,” said Alexander, “I got out of a ticket once. It was the simple truth that did it. After Greg died, I was on my way down to San Diego to attend the trial, and a cop stopped me and said I was speeding, and I said, 'Yes, I was.' I acknowledged it. Why bother with denial? i didn't care anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“So he's writing up the ticket, and I'm sitting there, and then for some reason, I think I was talking to myself, really, I said,'It's been a bad day.' The cop stopped writing and asked me what I meant. So I told him about Greg and the trial.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Were you crying?” Jane interrupted.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("He understood that she was teasing him, but he searched his memory anyway. “You know, I may have shed a tear. I don't remember. My feelings were still a little raw, you know, and I had a hard time saying out loud, 'My son is dead.' Those words didn't come easily.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“I remember at the trial, you broke down several times talking to the reporters.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“I know,” Alexander nodded thoughtfully. “I would see them coming, holding their microphones or their notebooks, and I would ready myself, plotting out what I was going to say so I could stay in control. It didn't always work.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("So much, Jane thought. Such a long list of terrible memories. Sometimes she reviewed them in her mind, not to continue the torture, but out of curiosity. How could anyone live through this, she would muse, confronting each ghost, considering each moment which, when lined up one next to the other, formed the incubus that haunted them.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“So,” said Jane, shaking off the vision, “he believed you.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Yeah. He said, 'Okay, I'll buy it.' He told me to take care of myself and drive slower and he sent me on my way.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Jane considered this for a moment. “I should have cried. That's where I went wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Alexander grinned and leaned across her, extinguishing the light. They were quiet for a moment, and he thought she was asleep.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('i', [_vm._v("Jane's like that. She emotes. I brood. She's mad as hell and then she lets it all out and it's over, just like that. I carry my anger around for days, until it finally goes away because I've analyzed it to death.")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('i', [_vm._v("We're okay, though. We've survived so far because we always seem to end up here, in this bed, in the middle of the night or early in the morning, talking things over. Most people spend time in bed sleeping or making love. We spend time surviving.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Jane wasn't asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Al, have you ever thought about where we live?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Hmm. We live in San Jose.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“No, our street.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“We live on Copeland Place.” It took only a moment. Laughter, long and hard, rose up between them.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Maybe we should put up a sign,” said Al.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Yeah,” Jane agreed, “welcome to cope-land.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("They began laughing again, the bed shaking, reaching over to hush each other and keep the rest of the household from joining them.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("In the flickering darkness made by his favorite candle, Guy floated dreamily under the soft down of his comforter. From somewhere, the sound of laughter drifted through his semiconsciousness.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("He opened his eyes. In the soft light, he could view the landscape of his room. He closed his eyes again, feeling safe, his possessions surrounding him like sentries on their last watch, protecting the last little prince in the castle tower.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The laughter got louder. Guy listened, more aware now of where it was coming from. He leaned his head toward his parents' room, enjoying the sounds. Then he heard the front door close behind Anne, and James' step on the stairs. He smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The circle. Guy, Jane, Alexander, James, and Anne. Guy had no need for anyone else to come close. It was good to have the affirming applause of his audiences, and thousands of letters from thankful kids, assuring him that he would be remembered. But to spend precious, borrowed time, Guy had no need, no desire for others.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb068b9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/09_chapter03.vue
// module id = 84
// module chunks = 0